import { useContext } from 'react';

import i18n from '@nextroll/ar-i18n';

import ThemeWrapperContext from '../../../contexts/ThemeWrapperContext';
import PageBanner from '../PageBanner';

const NotFoundView = () => {
    const { supportEmail } = useContext(ThemeWrapperContext);

    const topText = i18n.gettext('Email verification link not valid');
    const bottomText = i18n.gettext(
        'Looks like the verification link is not valid for this email address. Please make sure you are logged into the right account and try again.'
    );

    return (
        <div className='eh-ev-form-view-not-found'>
            <PageBanner topText={topText} bottomText={bottomText} />
            <p className='email-change-page-form-help-center'>
                {i18n.gettext(
                    'Need additional help? Reach out to <LINK>{{supportEmailAddress}}</LINK><br />or your Account Executive.',
                    {
                        LINK: (
                            <a
                                href={`mailto:${supportEmail}`}
                                target='_blank'
                            />
                        ),
                        supportEmailAddress: supportEmail,
                    }
                )}
            </p>
        </div>
    );
};

export default NotFoundView;
